import { render, staticRenderFns } from "./addKickPlayeOut.vue?vue&type=template&id=5b1a4c86&scoped=true&"
import script from "./addKickPlayeOut.vue?vue&type=script&lang=js&"
export * from "./addKickPlayeOut.vue?vue&type=script&lang=js&"
import style0 from "./addKickPlayeOut.vue?vue&type=style&index=0&id=5b1a4c86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1a4c86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b1a4c86')) {
      api.createRecord('5b1a4c86', component.options)
    } else {
      api.reload('5b1a4c86', component.options)
    }
    module.hot.accept("./addKickPlayeOut.vue?vue&type=template&id=5b1a4c86&scoped=true&", function () {
      api.rerender('5b1a4c86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/serverManagement/components/addKickPlayeOut.vue"
export default component.exports